const imageLoader = ( {src}: {src:string} ) => {
    return src;
}

export default imageLoader;